export default __webpack_public_path__ + "static/benifitImg-ab0cc67d04e07ed83611861cabc66b48.png";